import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import QRCode from "react-qr-code";
import { DataAPi } from "../variable/dataVariable";

function RincianVA() {
        const [data, setData] = useState([]);
        
        const {customerNo, virtualAccountNo, nama, nim, prodi, fakultas, billCode, billName, billAmountValue, billDescription, paidAmount, trxDateTime, referenceNo, paymentFlagReason} = useParams()
        
    return(
        <>
        <div className="container bg-light my-4">
            <div className="row justify-content-md-center g-3">
                <div className="col-md-12 text-center">
                    <h5 className="my-4">Detial Transaksi</h5>
                </div>
                <div className="col-md-8">
                        <table className="table table-primary border" style={{width: "100%"}}>
                            <tr>
                                <td><h6>Nama</h6></td>
                                <td>:</td>
                                <td>{nama}</td>
                            </tr>
                            <tr>
                                <td><h6>NIM</h6></td>
                                <td>:</td>
                                <td>{nim}</td>
                            </tr>
                            <tr>
                                <td><h6>Jurusan/Program Studi</h6></td>
                                <td>:</td>
                                <td>{prodi}</td>
                            </tr>
                            <tr>
                                <td><h6>Fakultas</h6></td>
                                <td>:</td>
                                <td>{fakultas}</td>
                            </tr>                       
                        </table>
                </div>
                
                <div className="col-md-12 row g-1">
                    
                    <h5 className="my-4">Detail Virtual Akun</h5>
                    <table className="table table-striped border" style={{width: "100%"}}>
                        <thead>
                            <tr className="table-primary text-center border">
                                <th className="text-center border">Nomor Virtual Akun</th>
                                <th className="text-center border">Kode Kegiatan</th>
                                <th className="text-center border">Nama Kegiatan</th>
                                <th className="text-center border">Jumlah Tagihan</th>
                                <th className="text-center border">Keterangan</th>
                            </tr>
                        </thead>
                            <tr>
                                <td className="text-center border">{virtualAccountNo}</td>
                                <td className="text-center border">{billCode}</td>
                                <td className="text-center border">{billName}</td>
                                <td className="text-center border">{billAmountValue}</td>
                                <td className="text-center border">{billDescription}</td>
                            </tr>
                    </table>
                    <h5 className="my-4">Histori Transaksi</h5>
                    <table className="table table-striped border" style={{width: "100%"}}>
                        <thead>
                            <tr className="table-primary text-center border">
                                <th className="text-center border">Jumlah Tagihan</th>
                                <th className="text-center border">Jumlah Bayar</th>
                                <th className="text-center border">Tanggal Transaksi</th>
                                <th className="text-center border">Nomor Referensi</th>
                                <th className="text-center border">Status Pembayaran</th>
                            </tr>
                        </thead>
                            <tr>
                                <td className="text-center border">{billAmountValue}</td>
                                <td className="text-center border">{paidAmount}</td>
                                <td className="text-center border">{trxDateTime}</td>
                                <td className="text-center border">{referenceNo}</td>
                                <td className="text-center border"><div class="btn" type="text" style={{width: "150px", fontSize: "12px", borderColor: "green", color: "green"}} disabled>{paymentFlagReason}</div></td>
                            </tr>
                    </table>
                    
                </div>
                
                <div className="col-md-6">
                    <Link to="/virtual-akun" className="btn btn-primary">Kembali</Link>
                </div>
                <div className="col-md-6">
                </div>
            </div>
        </div>
        </>
    )
}

export default RincianVA;